<script setup lang="ts">
// import { useI18n } from '#imports'

// import { useNuxtApp } from '#app/nuxt'
import { modalProps } from '~/components/base/modal/Modal.vue'

// const { $log } = useNuxtApp()
const { $ts } = useI18n()

const props = defineProps({
  ...modalProps,

  sessionExpired: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <Modal :canClose="!props.sessionExpired">
    <template #header>
      {{ $ts('login') }}
    </template>

    <template #default>
      <p v-if="props.sessionExpired">
        {{ $ts('sessionExpiredLogin') }}
      </p>
    </template>

    <template #footer>
      <Button
        block
      >
        {{ $ts('login') }}
      </Button>
    </template>
  </Modal>
</template>
